import router from '@/router'
import createWebSocket from '@/store/connection'

export default {
  namespaced: true,
  state: {
    // Connection
    connectionError: null,
    connected: false,
    connectionFailed: false,
    userGuid: null,
    // Games
    joinGame: null,
    createGame: null,
    joinedGame: null,
    createdGame: null,
    gameError: null,
    // In Game
    userPoints: null,
    gameStarted: false,
    gameState: null,
    quizname: null,
    quiz: null,
    adminSettings: null,
    currentQuestion: null,
    showWaitScreen: true,
    scoreModel: null,
    givenAnswers: null,
    tick: null,
    tickPercentage: '',
    answer: ''
  },
  getters: {
    connected: state => state.connected,
    connectionError: state => state.connectionError,
    connectionFailed: state => state.connectionFailed,
    gameError: state => state.gameError,
    gameState: state => state.gameState,
    adminSettings: state => state.adminSettings,
    quiz: state => state.quiz,
    createdGame: state => state.createdGame,
    joinedGame: state => state.joinedGame,
    currentQuestion: state => state.currentQuestion,
    showWaitScreen: state => state.showWaitScreen,
    tick: state => state.tick,
    gameStarted: state => state.gameStarted,
    tickPercentage: state => state.tickPercentage,
    answer: state => state.answer,
    scoreModel: state => state.scoreModel,
    givenAnswers: state => state.givenAnswers,
    userPoints: state => state.userPoints
  },
  mutations: {
    // Connection
    SET_CONNECTION (state, data) {
      state.connected = data
      if (data === true) {
        state.connectionError = null
      }
    },
    SET_ERROR (state, error) {
      state.connectionError = error
      state.connected = false
    },
    SET_CONNECTION_FAILED (state, error) {
      state.connectionError = error
      state.connectionFailed = true
    },
    SET_USER_GUID (state, guid) {
      state.userGuid = guid
      localStorage.setItem('quizUserGuid', guid)
    },
    GET_USER_GUID (state) {
      if (localStorage.getItem('quizUserGuid')) {
        this.replaceState(
          Object.assign(state, localStorage.getItem('quizUserGuid'))
        )
      }
    },
    SEND_CACHED_USER_GUID (state) {
      if (localStorage.getItem('quizUserGuid')) {
        state.userGuid = localStorage.getItem('quizUserGuid')
      }
    },

    // Join/create/leave games
    SET_JOIN_GAME (state, joinGame) {
      state.joinGame = joinGame // hub is subscribed to this mutation in the store
    },
    SET_JOINED_GAME (state, joinedGame) {
      state.joinedGame = joinedGame
    },
    SET_CREATE_GAME (state, createGame) {
      state.createGame = createGame // hub is subscribed to this mutation in the store
    },
    SET_CREATED_GAME (state, createdGame) {
      state.createdGame = createdGame
    },
    LEAVE_GAME (state) {
      state.joinedGame = null // hub is subscribed to this mutation in the store
      state.createdGame = null
      state.gameError = null
      state.quiz = null
      router.push('/')
    },
    SET_GAME_ERROR (state, error) {
      state.gameError = error
    },

    // Admin functions
    SET_QUIZ (state, quiz) {
      state.quiz = quiz // hub is subscribed to this mutation in the store
    },
    SET_QUIZNAME (state, quizname) {
      state.quizname = quizname
    },
    START_GAME (state) {
      // STARTING GAME (hub is subscribed to this mutation in the store)
    },
    NEXT_QUESTION (state) {
      // NEXT QUESTION (hub is subscribed to this mutation in the store)
    },
    SET_JOIN_SCORE (state, joinGame) {
      state.joinGame = joinGame // hub is subscribed to this mutation in the store
    },

    // In quiz
    UPDATE_GAMESTATE (state, gameState) {
      state.gameState = gameState
    },
    ANSWER_QUESTION (state, answer) {
      state.answer = answer // hub is subscribed to this mutation in the store
    },
    GET_NEXT_QUESTION (state, question) {
      state.currentQuestion = question
      state.showWaitScreen = false
      state.answer = ''
    },
    SHOW_WAIT_SCREEN (state) {
      state.showWaitScreen = true
      state.connectionError = ''
    },
    SET_USER_POINTS (state, userPoints) {
      state.userPoints = userPoints // hub is subscribed to this mutation in the store
      localStorage.setItem('quizUserPoints', userPoints)
    },
    RESTORE_USER_POINTS (state) {
      if (!state.userPoints || state.userPoints == null) {
        if (localStorage.getItem('quizUserPoints')) {
          state.userPoints = localStorage.getItem('quizUserPoints')
        }
      }
    },
    SET_TICK (state, tick) {
      tick.Remaining = parseInt(tick.Remaning * 1000)
      state.tick = tick
      var remaining = 1 - parseFloat(tick.Percentage)
      remaining = remaining * 100
      state.tickPercentage = remaining + '%'
    },
    SET_GAME_STARTED (state) {
      state.gameStarted = true
    },
    UPDATE_GAMESCORE (state, score) {
      state.scoreModel = score
    },
    UPDATE_GIVEN_ANSWERS (state, answers) {
      state.givenAnswers = answers
    }
  },
  actions: {
    // Connection
    connectionOpened ({ commit }) {
      commit('SET_CONNECTION', true)
      commit('SEND_CACHED_USER_GUID')
      commit('RESTORE_USER_POINTS')
    },
    connectionClosed ({ commit }) {
      commit('SET_CONNECTION', false)
    },
    connectionError ({ commit }, error) {
      commit('SET_ERROR', error)
    },
    connectionFailed ({ commit }, error) {
      commit('SET_CONNECTION_FAILED', error)
    },
    setUserGuid ({ commit }, guid) {
      commit('SET_USER_GUID', guid)
    },
    getUserGuid ({ commit }) {
      commit('GET_USER_GUID')
    },

    // Join/create/leave games
    joinGame ({ commit }, joinGame) {
      commit('SET_JOIN_GAME', joinGame)
    },
    setJoinedGame ({ commit }, joinedGame) {
      commit('SET_JOINED_GAME', joinedGame)
      router.push('/joinedgame')
    },
    createGame ({ commit }, createGame) {
      commit('SET_CREATE_GAME', createGame)
    },
    setCreatedGame ({ commit }, createdGame) {
      commit('SET_CREATED_GAME', createdGame)
      router.push('/admingame')
    },
    leaveGame ({ commit }) {
      commit('LEAVE_GAME')
    },
    setGameError ({ commit }, error) {
      commit('SET_GAME_ERROR', error)
    },

    // Admin functions
    setQuiz ({ commit }, quiz) {
      commit('SET_QUIZ', quiz)
    },
    setQuizname ({ commit }, quizname) {
      commit('SET_QUIZNAME', quizname)
    },
    startGame ({ commit }) {
      commit('START_GAME')
    },
    nextQuestion ({ commit }) {
      commit('NEXT_QUESTION')
    },
    joinScore ({ commit }, joinGame) {
      commit('SET_JOIN_SCORE', joinGame)
    },

    // In quiz
    updateGamestate ({ commit }, gameState) {
      commit('UPDATE_GAMESTATE', gameState)
    },
    updateGameScore ({ commit }, gameScore) {
      commit('UPDATE_GAMESCORE', gameScore)
    },
    updateGivenAnswers ({ commit }, givenAnswers) {
      commit('UPDATE_GIVEN_ANSWERS', givenAnswers)
    },
    answerQuestion ({ commit }, answer) {
      commit('ANSWER_QUESTION', answer)
    },
    getNextQuestion ({ commit }, question) {
      commit('GET_NEXT_QUESTION', question)
    },
    showWaitScreen ({ commit }) {
      commit('SHOW_WAIT_SCREEN')
    },
    setTick ({ commit }, tick) {
      commit('SET_TICK', tick)
    },
    gameStarted ({ commit }) {
      commit('SET_GAME_STARTED')
    },
    setUserPoints ({ commit }, userPoints) {
      commit('SET_USER_POINTS', userPoints)
    }
  },
  modules: {
  },
  plugins: [createWebSocket()]
}
